import {
  Component,
  OnInit,
  ElementRef,
  Input,
  ViewChild
} from "@angular/core";
import { DialogService } from "../dialog";
import { DialogComponent } from "../dialog/dialog.component";
import { DataService } from "../../services/data.service";
import { environment } from "../../../../environments/environment";
export interface ConfirmModel2 {
  title: string;
  message: string;
}

@Component({
  selector: 'app-product-search',
  templateUrl: './product-search.component.html',
  styleUrls: ['./product-search.component.css']
})
export class ProductSearchComponent extends DialogComponent<ConfirmModel2, boolean>
  implements ConfirmModel2, OnInit {
  title: string;
  message: string;
  loading: boolean = false;
  result: any = { item: [], result: false };;
  rtnData: any;
  selectedRow: number = -1;
  sliceStrat: number = 0;
  sliceEnd: number = 15;
  Unit: string = "";
  f: any = {
    Name: "",
    Barcode: "",
    RefNo: "",
    CostPrice: "",
    SellingPrice: "",
    SupplierName: "",
    StkQty: ""
  };
  ItemSearchCost: boolean
  private el: ElementRef;
  @Input() onReturn: string;
  @ViewChild("itemName") itemName: ElementRef;
  @ViewChild("refno") refno: ElementRef;
  ItemSearchFilterOnChange: boolean = false;
  FocusRefNoOnItemSearch: boolean = false;
  ShowStockQtyInItemlist: boolean = false;
  constructor(dialogService: DialogService, private ds: DataService) {
    super(dialogService);
    this.fullData = ds.ItemDetails;
  }
  fullData: any;

  ngOnInit() {
    this.ItemSearchCost = environment.ShowCostPriceOnItemSearch

    var iw = (this.ds.Settings.ItemSearchFilterOnChange)
    this.ItemSearchFilterOnChange = iw.toLowerCase() == 'true'

    var fc = (this.ds.Settings.FocusRefNoOnItemSearch)
    this.FocusRefNoOnItemSearch = fc.toLowerCase() == 'true'

    var isx = (this.ds.Settings.ShowStockQtyInItemlist)
    this.ShowStockQtyInItemlist = isx.toLowerCase() == 'true'

    if (!this.fullData) {
      this.close();
    } else {
      this.loading = true;
    }
  }
  ngAfterViewInit() {
    setTimeout(() => {
      if (this.FocusRefNoOnItemSearch) {
        this.refno.nativeElement.focus();
      }
      else {
        this.itemName.nativeElement.focus();
      }
    }, 1300);
  }
  confirm(item) {
    this.result = { item: item, result: true };
    this.close();
  }
  setClickedRow(e) {
    this.selectedRow = e;
    document.getElementById("focus").focus();
  }
  NextBut() {
    if (!this.NexbutEnable()) {
      this.fullData = this.ds.ItemDetails;
      this.sliceEnd = Number(this.sliceEnd) + 15
      this.selectedRow = 0
    }
  }
  PreBut() {
    if (!this.PrebutEnable()) {
      this.fullData = this.ds.ItemDetails;
      this.sliceEnd = Number(this.sliceEnd) - 15
      this.selectedRow = 0
    }
  }
  NexbutEnable(): boolean {
    return this.fullData.data.legth > this.sliceEnd
  }
  PrebutEnable(): boolean {
    return this.sliceEnd < 16
  }
  ItesmSearch(e, type) {
    if (this.ItemSearchFilterOnChange) {
      this.ItemSearchOnChange(e, type);
    }
    else {
      if (e.keyCode == 13 && e.which == 13) {
        this.ItemSearchOnChange(e, type);

        // this.fullData = this.ds.ItemDetails;
        // switch (type) {
        //   case "Barcode":
        //     this.f.Barcode = e.target.value;
        //     break;
        //   case "Name":
        //     this.f.Name = e.target.value;
        //     break;
        //   case "RefNo":
        //     this.f.RefNo = e.target.value;
        //     break;
        //   case "CostPrice":
        //     this.f.CostPrice = e.target.value;
        //     break;
        //   case "SellingPrice":
        //     this.f.SellingPrice = e.target.value;
        //     break;
        //   case "SupplierName":
        //     this.f.SupplierName = e.target.value;
        //     break;
        // }
        // this.selectedRow = 0;
      } else if (e.keyCode == 40 && e.which == 40) {
        document.getElementById("focus").focus();
        this.selectedRow = 0;
      }
    }

  }

  ItemSearchOnChange(e, type) {
    this.fullData = this.ds.ItemDetails;
    switch (type) {
      case "Barcode":
        this.f.Barcode = e.target.value;
        break;
      case "Name":
        this.f.Name = e.target.value;
        break;
      case "RefNo":
        this.f.RefNo = e.target.value;
        break;
      case "CostPrice":
        this.f.CostPrice = e.target.value;
        break;
      case "SellingPrice":
        this.f.SellingPrice = e.target.value;
        break;
      case "SupplierName":
        this.f.SupplierName = e.target.value;
        break;
      case "StkQty":
        this.f.StkQty = e.target.value;
        break;
    }
    this.selectedRow = 0;
  }

  scroll(event: KeyboardEvent) {
    //up 38 down 40
    event.preventDefault();
    if (event.keyCode === 40) {
      if (this.selectedRow > 13) {
        this.NextBut();
      } else {
        this.selectedRow++;
      }
    } else if (event.keyCode === 38) {
      if (this.selectedRow < 1) {
        this.PreBut();
      } else {
        this.selectedRow--;
      }
    } else if (event.keyCode === 13) {
      this.selecedItem();
    }
    else return;
  }
  selecedItem() {
    var abc = document.getElementsByClassName("selectedItesmsaerch786")[0].getElementsByClassName("bkd")[0].innerHTML;
    var bcd = this.fullData.data.find(x => x.Barcode == abc);
    this.confirm(bcd);
  }
  refresh() {
    this.ds.loadItems();
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/iPOSERP/src/app/shared/component/product-search/product-search.component.ts